<template>
  <div class="vx-row" v-if="data">
    <!-- Taxa por estabelecimento -->
    <div class="vx-col lg:w-1/2 w-full">
      <vx-card>
        <h4 class="mb-4">{{ $t('cancellation.index_by_establishment') }}</h4>

        <div v-for="entity in data.by_establishment" :key="entity.legal_entity_id" class="mb-3">
          <div class="flex justify-between mb-50">
            <small class="text-muted">{{ entity.name }}</small>
            <small :class="'text-' + rateColor(entity.rate)" class="font-medium">
              {{ formatRate(entity.rate) }}
            </small>
          </div>
          <b-progress :max="20" height="8px">
            <b-progress-bar :value="entity.rate" :variant="rateColor(entity.rate)"/>
          </b-progress>
        </div>

        <div class="flex justify-between border-top pt-3">
          <small class="text-muted">{{ $t('cancellation.index_platform_avg') }}</small>
          <small class="font-medium">{{ formatRate(data.platform_rate) }}</small>
        </div>
      </vx-card>
    </div>

    <div class="vx-col lg:w-1/2 w-full">
      <!-- Origem -->
      <vx-card class="mb-4">
        <h4 class="mb-3">{{ $t('cancellation.index_origin') }}</h4>

        <b-progress :max="100" height="12px" class="mb-2">
          <b-progress-bar :value="data.origins.student" variant="primary"/>
          <b-progress-bar :value="data.origins.establishment" variant="warning"/>
          <b-progress-bar :value="data.origins.payment_failure" variant="danger"/>
        </b-progress>

        <div class="flex justify-between mb-50">
          <small class="text-muted">
            <span class="bullet bullet-primary bullet-sm mr-50"/>{{ $t('cancellation.origin_.ST') }}
          </small>
          <small>{{ data.origins.student }}%</small>
        </div>
        <div class="flex justify-between mb-50">
          <small class="text-muted">
            <span class="bullet bullet-warning bullet-sm mr-50"/>{{ $t('cancellation.origin_.ES') }}
          </small>
          <small>{{ data.origins.establishment }}%</small>
        </div>
        <div class="flex justify-between">
          <small class="text-muted">
            <span class="bullet bullet-danger bullet-sm mr-50"/>{{ $t('cancellation.origin_.PF') }}
          </small>
          <small>{{ data.origins.payment_failure }}%</small>
        </div>
      </vx-card>

      <!-- Modalidade e professor -->
      <vx-card>
        <h4 class="mb-3">{{ $t('cancellation.index_modality') }}</h4>
        <b-table-simple small responsive>
          <b-thead>
            <b-tr>
              <b-th>{{ $t('cancellation.modality') }}</b-th>
              <b-th>{{ $t('cancellation.teacher') }}</b-th>
              <b-th class="text-right">{{ $t('cancellation.rate') }}</b-th>
              <b-th class="text-right">{{ $t('cancellation.rescheduled') }}</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(row, i) in data.by_product" :key="i">
              <b-td>{{ row.modality }}</b-td>
              <b-td>{{ row.teacher || '—' }}</b-td>
              <b-td class="text-right">{{ formatRate(row.rate) }}</b-td>
              <b-td class="text-right">{{ row.rescheduled }}%</b-td>
            </b-tr>
            <b-tr v-if="!data.by_product.length">
              <b-td colspan="4" class="text-center text-muted">Nenhum registro encontrado</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {
  BProgress,
  BProgressBar,
  BTableSimple,
  BTbody,
  BTd,
  BTh,
  BThead,
  BTr
} from 'bootstrap-vue'

import CancellationRequestService from '@/services/api/CancellationRequestService'

export default {
  components: {
    BProgress,
    BProgressBar,
    BTableSimple,
    BTbody,
    BTd,
    BTh,
    BThead,
    BTr
  },
  data: () => ({
    service: null,
    data: null
  }),
  methods: {
    formatRate(rate) {
      return `${String(rate).replace('.', ',')}%`
    },
    rateColor(rate) {
      if (rate >= 12) return 'danger'
      if (rate >= 7) return 'warning'
      return 'success'
    }
  },
  beforeMount() {
    this.service = CancellationRequestService.build(this.$vs)
  },
  mounted() {
    this.$vs.loading()
    this.service.indexStats().then(
      data => { this.data = data },
      () => {}
    ).finally(() => { this.$vs.loading.close() })
  }
}
</script>

<style lang="scss" scoped>
.bullet {
  display: inline-block;
  border-radius: 50%;
  &.bullet-sm {
    width: 10px;
    height: 10px;
  }
  &.bullet-primary { background: var(--primary, #8bb2db); }
  &.bullet-warning { background: #ff9f43; }
  &.bullet-danger { background: #ea5455; }
}
</style>
